import { DC_Domain_Models_Products_ProductType } from '@monorepo-types/dc';

import { ReadingContext, StepValue } from './MeterReadingsFlow.types';

export const addStep =
  (step: StepValue, addStepOnIndex = 0) =>
  (context: ReadingContext): StepValue[] => {
    const steps = [...context.steps];

    if (!steps.some(({ state }) => state === step.state)) {
      steps.splice(addStepOnIndex, 0, step);
    }

    return steps;
  };

const hasMeterForProductType = (productType: DC_Domain_Models_Products_ProductType, meters: ReadingContext['meters']) =>
  !!meters?.[productType];

export const hasElectricityMeter = (meters: ReadingContext['meters']) => hasMeterForProductType('electricity', meters);

export const isMissingElectricityMeter = (...params: Parameters<typeof hasElectricityMeter>) =>
  !hasElectricityMeter(...params);

export const hasGasMeter = (meters: ReadingContext['meters']) => hasMeterForProductType('gas', meters);

export const isMissingGasMeter = (...params: Parameters<typeof hasGasMeter>) => !hasGasMeter(...params);

export const hasWarmthMeter = (meters: ReadingContext['meters']) => hasMeterForProductType('warmth', meters);

export const isMissingWarmthMeter = (...params: Parameters<typeof hasWarmthMeter>) => !hasWarmthMeter(...params);

export const hasCoolingMeter = (meters: ReadingContext['meters']) => hasMeterForProductType('cooling', meters);

export const isMissingCoolingMeter = (...params: Parameters<typeof hasCoolingMeter>) => !hasCoolingMeter(...params);

export const hasTapwaterMeter = (meters: ReadingContext['meters']) => hasMeterForProductType('tapwater', meters);

export const isMissingTapWaterMeter = (...params: Parameters<typeof hasTapwaterMeter>) => !hasTapwaterMeter(...params);
